import { Box, Button, Notification } from '@codeparva/ui-components-library';
import React from 'react';
import { useFormik } from 'formik';
import { UserFlowTypes } from '..';
import { forgotPasswordFormSchema } from './formValidationSchema';
import { UserFlowError } from './UserFlowError';
import { Icon } from '../../../utilities/icomoon-css';
import { SectionCardTitle } from '../../../components/textVariations';
import { Link } from 'gatsby';

export const ForgotPassword = ({
  sendAccessCode,
}: UserFlowTypes.TForgotPassword) => {
  const [notification, setNotification] = React.useState(false);
  const [error, setError] = React.useState<any>();
  const [hasError, setHasError] = React.useState(false);

  const ForgotPasswordForm = () => {
    const formik = useFormik({
      initialValues: {
        userName: '',
      },
      validationSchema: forgotPasswordFormSchema,

      onSubmit: values => {
        sendAccessCode(values.userName, setNotification, setError, setHasError);
      },
    });
    return (
      <form onSubmit={formik.handleSubmit}>
        <div>
          <label className="titleColor">
            Enter your email address
            <span className="requiredAsterisk">*</span>
          </label>
          <br></br>
          <input
            id="userName"
            name="userName"
            type="email"
            placeholder="email id"
            className="inputForgotPasswordField"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.userName}
          />
          {formik.touched.userName && formik.errors.userName ? (
            <div className="errorForgotPasswordSection">
              <div className="errorForgotPasswordIconSpace">
                <Icon name="tfw-danger-triangle-cp" size={12} color="red" />
              </div>
              <div className="errorForgotPasswordMessage content1">
                {formik.errors.userName}
              </div>
            </div>
          ) : (
            <></>
          )}
          <p className="helperMessage">
            Enter your email address to send Password reset link
          </p>
        </div>
        {UserFlowError(hasError, error)}

        <div className="sendButton">
          <Button
            className="cp-primary-button-highlighted buttonColor"
            disabled={!formik.isValid || !formik.dirty}
          >
            Send
          </Button>
          <Link to="../login" className="forgotPasswordLink">
            Go to Login Page
          </Link>
        </div>
      </form>
    );
  };
  return (
    <div className="parentForgotPasswordSection">
      <div className="titleContainer">
        <SectionCardTitle>Forgot Password</SectionCardTitle>
      </div>
      <div className="boxForgotPasswordSection">
        {notification ? (
          <div className="notificationSection">
            <Notification className="notificationColor">
              Access code has been sent to your email
              <button
                className="delete"
                onClick={() => setNotification(false)}
              ></button>
            </Notification>
          </div>
        ) : (
          <></>
        )}
        <div>
          <Box className="boxForgotPasswordPadding">
            <ForgotPasswordForm />
          </Box>
        </div>
      </div>
    </div>
  );
};
